/**
 * GST handling for Indian (INR) checkouts.
 *
 * Cashfree does NOT add tax to plan_amount — it charges exactly what we send.
 * So we fold GST into the charged amount and surface the breakdown in the UI.
 * International (USD) flows are zero-rated exports and never call this.
 */
export const GST_RATE = 0.18;

export interface GstBreakdown {
  base: number;
  gst: number;
  total: number;
}

export function applyGst(base: number): GstBreakdown {
  const gst = Math.round(base * GST_RATE);
  return { base, gst, total: base + gst };
}

export function formatInr(n: number): string {
  return `₹${n.toLocaleString("en-IN")}`;
}